<template>
    <div class="app-max-width" style="text-align: center; margin-top:10px">
        <h1>{{$ta(measuresection.title_textassetid)}}</h1>
        <ContentRenderer v-if="!hide" :content="measuresection.content"></ContentRenderer>
        <v-btn v-if="initiated && !hide" color="primary" @click="next()">{{$t('general.continue')}}</v-btn>
    </div>
</template>

<script>
  import ContentRenderer from "../../../content/ContentRenderer";
  import applicationEventHub from "../../../../events/applicationEventHub";
  export default {
    name: "MeasureSection",
    components:{
      ContentRenderer
    },
    props:{
      measuresection:{type:Object,required:true}
    },
    created(){
      applicationEventHub.$on('framework.next',this.next);
    },
    mounted(){
      applicationEventHub.frameworkButtonState(true,false);
      setTimeout(()=>{
        this.initiated=true;
      },800);
    },
    data(){
      return {
        hide : false,
        initiated : false,
      }
    },
    methods:{
      next(){
        this.hide=true;
        this.$nextTick(()=>{
          this.$store.dispatch('assessment/setSectionIntroDisplayed',this.measuresection.measuresectionid);
          this.$emit('next');
        });
      }
    },
    beforeDestroy() {
      applicationEventHub.frameworkButtonState(true,true);
      applicationEventHub.$off('framework.next',this.next);
    }
  }
</script>

<style scoped>

</style>